export default "__VITE_ASSET__DFbcwJuz__"